import React, { Component } from 'react';

export default class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            email: '', 
            name: '', 
            seismic: 'UofT Seismic Design Team',
            msg: 'Want to learn more about our team and get involved? Sign up to our mailing list 😃'
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        if(event.target.id === 'email'){
            this.setState({email: event.target.value});
        }else{
            this.setState({name: event.target.value});
        }
    }
    
    handleSubmit (event) {
        if(this.state.email === "" || this.state.name === "" || !this.state.email.includes('@')){
            this.setState({msg: 'please enter valid information'});
        }else{
            const templateId = 'template_tmYxXUDQ';
            const serviceId = 'seismic_design_team';
            this.sendFeedback(serviceId, templateId, {message_html: "Thank you for your interest in seismic! You are now on our mailing list", to_name: this.state.name, from_name: this.state.seismic, reply_to: this.state.email})
            this.setState({
                email: '',
                name: '',
                msg: 'Thanks for your interest! 😊'
            })
        }
    }

    sendFeedback (serviceId, templateId, variables) {
        window.emailjs.send(
            serviceId, templateId,
            variables
            ).then(res => {
            console.log('Email successfully sent!')
            })
            .catch(err => console.error('Oh well, you failed. Here some thoughts on the error that occured:', err))
    }

    render() {
        return (
            <footer className="footer" id="contact">
                <div className="container-fluid">
                    <div className="row pt-4 pb-4">
                        {/* Location Section */}
                        <div className="col-lg-4 col-md-6 mb-4">
                            <div className="footer-section">
                                <h5 className="footer-title mb-3">
                                    <b>Where to Find Us</b>
                                </h5>
                                <div className="location-info">
                                    <a 
                                        href="https://goo.gl/maps/RLZP6CnBAhmEmBMbA" 
                                        className="location-link mb-2 d-block"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        University of Toronto
                                    </a>
                                    <p className="address-text mb-0">
                                        55 St George St,<br />
                                        Toronto, Ontario, Canada<br />
                                        M5S 0C9<br />
                                        University of Toronto, St. George Campus
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Map Section */}
                        <div className="col-lg-4 col-md-6 mb-4">
                            <div className="footer-section text-center">
                                <iframe 
                                    id="map" 
                                    className="location-map"
                                    width="100%" 
                                    height="200"
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5772.779672101349!2d-79.40141247210562!3d43.660861596362174!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b34c759aac983%3A0x22314ceb9e69c275!2s55%20St%20George%20St%2C%20Toronto%2C%20ON%20M5S%200C9!5e0!3m2!1sen!2sca!4v1750115934385!5m2!1sen!2sca" 
                                    title="University of Toronto Location" 
                                    style={{border: 0, borderRadius: '8px'}}
                                    loading="lazy"
                                />
                            </div>
                        </div>

                        {/* Social Media Section */}
                        <div className="col-lg-4 col-md-12 mb-4">
                            <div className="footer-section text-center">
                                <h5 className="footer-title mb-3">
                                    <b>Connect With Us</b>
                                </h5>
                                <div className="social-links">
                                    <a 
                                        href="https://www.linkedin.com/company/43272649" 
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="social-link"
                                        aria-label="LinkedIn"
                                    >
                                        <i className="fa fa-linkedin" style={{fontSize: '2.5rem', marginRight: '1rem'}} />
                                    </a>
                                    <a 
                                        href="https://www.youtube.com/channel/UCugrQkMvhnQnwLsrQ_8Cvxg" 
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="social-link"
                                        aria-label="YouTube"
                                    >
                                        <i className="fa fa-youtube" style={{fontSize: '2.5rem', marginRight: '1rem'}} />
                                    </a>
                                    <a 
                                        href="https://www.instagram.com/uoftseismic/" 
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="social-link"
                                        aria-label="Instagram"
                                    >
                                        <i className="fa fa-instagram" style={{fontSize: '2.5rem'}} />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}